import React, { Component } from "react";
import intlTelInput from 'intl-tel-input';
import utilsScript from 'intl-tel-input/build/js/utils.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class AppointmentListLoginComponent extends Component {

    state = {
    };

    componentDidMount() {
        this.initializePhoneField();
    }

    initializePhoneField = () => {
        const input = document.querySelector("#phone");
        this.state.phoneInput = intlTelInput(input, {
            // any initialisation options go here
            preferredCountries: ["rs", "ba", "hr", "me", "mk" ,"si", "de", "at", "ch"],
            nationalMode: true,
            utilsScript: utilsScript
        });
      }

      validirajPodatke = () => {
        const emailField = document.querySelector("#contact-email");

        // validiraj broj telefona
         if(!this.state.phoneInput.isValidNumber()) {
            toast.error("Broj telefona koji ste uneli nije u odgovarajućem formatu.");
            return false;
         }
        // validiraj email
         if (!emailField.value || !this.validateEmail(emailField.value)) {
            toast.error("Email adresa koju ste uneli nije u odgovarajućem formatu.");
           return false;
         }
        return true;
      };

      timestampToDateString = function (timestamp) {
        var date = new Date(+timestamp * 1000);
        var dan = date.getDate();
        var mesec = date.getMonth() + 1;
        var godina = date.getFullYear();
        var sat = date.getHours();
        var minut = date.getMinutes();
  
        return dan + "." + mesec + "." + godina + " u " + sat + "." + (minut <= 9 ? "0" + minut : minut) + "h";
      };

      validateEmail = (email) => {
        return email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      };
  

      izlistajRezervacije = () => {

        var podaciValidni = this.validirajPodatke();
        if (podaciValidni) {
          
            let retVal = {
              telefon: this.state.phoneInput.getNumber(),
              email: document.querySelector("#contact-email").value
            }
            
            // prosledi unete podatke glavnoj komponenti, ako su ve' u redu i prosli su validaciju
            this.props.onUserLogin(retVal);
        }
      };
  


    render() { 
        return (  
            <section className="section-xl bg-periglacial-blue one-screen-page-content text-center">
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                />
                <div className="shell">
                    <h2>Moje rezervacije</h2>
                    <div className="p text-width-medium">
                    <p className="big">Da biste izlistali svoje rezervacije, unesite isti broj telefona i e-mejl adresu koju ste uneli prilikom zakazivanja svog termina. <br/><br/> ** Napomena: Provera rezeracija se vrši samo za rezervacije kreirane online, ali ne i za rezervacije telefonom.</p>
                    </div>
                    <div
                    className="box-contacts box-contacts-vertical box-contacts-vertical-small box-wrap-content-interactive block-centered">
                    
                    <div className="box-contacts-col box-contacts-right">
                        <div className="box-contacts-block">
                            <div className="form-group">
                            <label className="form-label-outside" htmlFor="phone">Broj telefona</label>
                            <input id="phone" className="form-control" name="phone" type="tel" style={{width:"100%"}}/>
                            </div>
                            <div className="form-group">
                            <label className="form-label-outside" htmlFor="contact-email">Email</label>
                            <input className="form-control" id="contact-email" type="email" name="email"
                                data-constraints="@Email" ng-model="parametriPretrage.email"/>
                            </div>
                            <button id="confirmButton" className="btn btn-sm btn-primary btn-block btn-circle" onClick={this.izlistajRezervacije}>Proveri rezervacije</button>

                        
                        </div>
                    </div>
                    </div>

                </div>
                </section>
         
      );
    }
}
 
export default AppointmentListLoginComponent;